export default{
    cadastra:{
        method:'post',
        url:'avuso/cadastro'
    },
    delete:{
        method:'delete',
        url:'avuso/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'avuso/lista'
    },
    editar:{
        method:'get',
        url:'avuso/editar{/id}'
    },
    update:{
        method:'post',
        url:'avuso/update'
    },
    evento:{
        method:'get',
        url:'avuso/evento/2200{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
}